export default "__VITE_ASSET__DcFQkxEC__"